var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckRoundFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2109 25.4658C20.0099 25.4658 24.7109 20.7648 24.7109 14.9658C24.7109 9.16683 20.0099 4.46582 14.2109 4.46582C8.41195 4.46582 3.71094 9.16683 3.71094 14.9658C3.71094 20.7648 8.41195 25.4658 14.2109 25.4658ZM19.6458 12.106C19.9994 11.6817 19.9421 11.0512 19.5178 10.6976C19.0935 10.344 18.4629 10.4014 18.1094 10.8256L13.6781 16.1432C13.3314 16.5592 13.1365 16.7896 12.9808 16.9311L12.9749 16.9365L12.9685 16.9317C12.8007 16.8048 12.5857 16.5931 12.2028 16.2101L10.2514 14.2587C9.86085 13.8682 9.22769 13.8682 8.83717 14.2587C8.44664 14.6492 8.44664 15.2824 8.83716 15.6729L10.7886 17.6243L10.8294 17.6651C11.1559 17.9918 11.47 18.306 11.7622 18.527C12.0896 18.7745 12.5183 19.0073 13.0677 18.9824C13.6171 18.9574 14.023 18.6868 14.3266 18.4106C14.5976 18.1641 14.882 17.8228 15.1776 17.4679L15.2145 17.4235L19.6458 12.106Z",
    fill: "#56BE04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRoundFill);
export default __webpack_public_path__ + "static/media/check_round_fill.7a983556c563b818c79aa1adf8404daa.svg";
export { ForwardRef as ReactComponent };